import {
  type FC,
  type PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useLocation, useSearchParams } from 'react-router';

type ActiveTab = Record<'detail', string | null>;

const Context = createContext<ActiveTab>({ detail: null });

export const useProjectPageActiveTabState = () => {
  return useContext(Context);
};

export const ProjectPageActiveTabProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [activeTabState, setActiveTabState] = useState<ActiveTab>({
    detail: null,
  });

  const activeTab = searchParams.get('activeKey');

  const isShowingDiffPage = location.pathname.endsWith('diff');

  // biome-ignore lint/correctness/useExhaustiveDependencies: 既存のDependencyListを変更した際の影響が読めないためignoreしておく。把握している人がいればignoreがなくなるよう適切に変更すること。
  useEffect(() => {
    setActiveTabState((prev) => ({
      detail: isShowingDiffPage ? prev.detail : activeTab,
    }));
  }, [setActiveTabState, activeTab, isShowingDiffPage]);

  return <Context.Provider value={activeTabState}>{children}</Context.Provider>;
};
